<template>
  <v-app>

    <v-app-bar app color="white" flat fixed>
      <a href="/" style="color:#000000; text-decoration:none">
      <v-toolbar-title color="black"><img style="margin-top:25px;height:40px;" src="/img/logo.png"></v-toolbar-title>
      </a>
      <v-spacer></v-spacer>
      <v-btn text outlined depressed href="tel:+390587735447"  ripple color="#000000" style="margin-top:10px;background-color:rgb(64, 211, 230)" @click="callUs()">CHIAMACI</v-btn>
    </v-app-bar>

    <v-content >
      <v-container>
        <router-view />
      </v-container>
    </v-content>

  </v-app>
</template>

<script>

import { isIOS } from 'mobile-device-detect';

export default {
  name: 'App',

  components: {
  },

  created(){
      if(!window.localStorage.getItem('onboarding')){
        const messageImage = (isIOS)?'addtohome':'android-addtohome';
        setTimeout(()=>{
          this.$swal({
            type: 'info',
            title: 'INSTALLA ADESSO L\'APPLICAZIONE',
            html: `Puoi aggiungere questa applicazione sul tuo telefono.<br><br><strong>in due semplici passaggi!</strong><br><img style="padding:10px;width:100%" src="/img/${messageImage}.png">`,
            footer: '',
            confirmButtonText: 'Ok, ho capito!',
          })
  
        },1000);
        window.localStorage.setItem('onboarding',1)
      }
  },

  data: () => ({

  }),
};
</script>

<style>
.swal2-container{
  font-family: "Roboto", sans-serif;
}

.swal2-styled.swal2-confirm {
  background-color: rgb(64, 211, 230) !important;
}

</style>